
import React from "react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

type AIProviderSelectorProps = {
  aiProvider: string;
  setAiProvider: (provider: string) => void;
  disabled?: boolean;
};

export const AIProviderSelector = ({ aiProvider, setAiProvider, disabled = false }: AIProviderSelectorProps) => {
  return (
    <div className="flex items-center gap-2">
      <Label className="text-white whitespace-nowrap">Choose AI Engine:</Label>
      <RadioGroup 
        value={aiProvider} 
        onValueChange={setAiProvider} 
        disabled={disabled}
        className="flex gap-4"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="openai" id="openai" />
          <Label htmlFor="openai" className="text-primary-light">OpenAI</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="deepseek" id="deepseek" />
          <Label htmlFor="deepseek" className="text-primary-light">DeepSeek</Label>
        </div>
      </RadioGroup>
    </div>
  );
};
